import React, { useEffect } from 'react'
import MemberCard from '../../../components/common/MemberCard'
import Navigator from '../../../components/common/Navigator'
import { useMembersList } from '../api'

const OurMembers = () => {
  const { data, isLoading, isError } = useMembersList()
  const members = data?.data ?? []

  useEffect(() => {
    if (!members.length) return
  }, [members])

  if (isLoading) {
    return (
      <section className="py-12 px-4">
        <p>Loading Members...</p>
      </section>
    )
  }

  if (isError) {
    return (
      <section className="py-12 px-4">
        <p>Error loading Members</p>
      </section>
    )
  }

  if (!members.length) {
    return (
      <section className="py-12 px-4">
        <p>No Members found.</p>
      </section>
    )
  }
  return (
    <div className="lg:w-11/12 mx-auto p-4 lg:p-0 lg:my-8">
      <Navigator title="Governing Council Members" slug="OUR_MEMBERS" />
      <h1 className="text-3xl font-semibold text-gray-800 pb-1">
        Governing Council Members
      </h1>
      <p className="text-gray-900 text-md pb-3">
        The operations of EDC are overseen by the Governing Council of KIED,
        consisting of the following members.
      </p>
      <hr className="border-t-2 border-primaryBlue mb-6" />
      <div className="lg:py-8 md:py-6 xs:py-5">
        <div
          className="
    grid
    grid-cols-1
    sm:grid-cols-2
    md:grid-cols-3
    lg:grid-cols-4
    xl:grid-cols-5
    gap-x-6
    gap-y-8
    justify-items-center
  "
        >
          {/* {members.map((member: any, idx: any) => (
            <MemberCard
              key={idx}
              name={member.name}
              designation={member.designation}
              //   image={member.photo?.replace(/\\/g, '')}
              image={member?.photo}
            />
          ))} */}
          {members
            .slice() // make a shallow copy
            .reverse() // reverse the order
            .map((member: any, idx: number) => (
              <MemberCard
                key={idx}
                name={member.name}
                designation={member.designation}
                image={member?.photo}
                edcDesignation={member.edc_designation}
              />
            ))}
        </div>
      </div>
    </div>
  )
}

export default OurMembers
